import { View } from 'backbone.marionette';
import template from './index.jst';
import './index.styl';

/**
 * @desc Table Layout Class
 */
export class TableLayout extends View {
	get className() {
		return "leagues-page";
	}

	get template() {
		return template;
	}

	regions() {
		return {
			header_page: '.header-page',
			table_menu:  '.table-menu',
			table_body:  '.table-body',
			load_more:   '.load-more'
		}
	}
}

export default TableLayout;